export class City {
    key! : string;
    name! : string;
    region! : string;
    regionId!: string;
    radius: number = 20;
    country! : string;
    readonly distance_unit : string = "miles";
}